import React from 'react'
import { LIBERTY_IMAGES } from '../assets/asset'
import { useNavigate } from 'react-router-dom'
const PdaiDex = () => {
    const navigate = useNavigate()
    return (
        <>
            <main className="pt-16 md:pt-20 pb-16 md:pb-0">
                {/*$*/}
                {/*/$*/}
                <div className="max-w-7xl mx-auto md:p-10 p-4 space-y-4">
                    <div className="relative w-full">
                        <div className="hidden md:block relative">
                            <div
                                className="relative rounded-xl overflow-hidden"
                                style={{
                                    background:
                                        "linear-gradient(rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.1) 100%)",
                                    padding: 1
                                }}
                            >
                                <div className="relative rounded-xl overflow-hidden bg-black h-full">
                                    <div className="absolute inset-0">
                                        <img
                                            alt="Banner Background"
                                            loading="lazy"
                                            decoding="async"
                                            data-nimg="fill"
                                            className="object-cover"
                                            src={LIBERTY_IMAGES.HORIZONTAL_DEX_BANNER}
                                            style={{
                                                position: "absolute",
                                                height: "100%",
                                                width: "100%",
                                                inset: 0,
                                                color: "transparent"
                                            }}
                                        />
                                    </div>
                                    <div className="relative p-6">
                                        <div className="flex items-start justify-between mb-4">
                                            <div className="flex items-center justify-center space-x-3">
                                                <div className="relative">
                                                    <img
                                                        alt="Dai Stablecoin"
                                                        loading="lazy"
                                                        width={40}
                                                        height={40}
                                                        decoding="async"
                                                        data-nimg={1}
                                                        className="object-contain"
                                                        src={LIBERTY_IMAGES.PDAI_AVATAR}
                                                        style={{ color: "transparent" }}
                                                    />
                                                </div>
                                                <div>
                                                    <h1 className="text-white text-xl font-bold">
                                                        Dai Stablecoin
                                                    </h1>
                                                    <div className="flex items-center space-x-2">
                                                        <span className="text-gray-300 text-sm font-mono">
                                                            0x6B17...1d0F
                                                        </span>
                                                        <button className="text-gray-400 hover:text-white transition-colors">
                                                            <img
                                                                alt="Copy Order ID"
                                                                loading="lazy"
                                                                width={20}
                                                                height={20}
                                                                decoding="async"
                                                                data-nimg={1}
                                                                className="brightness-0 invert"
                                                                src={LIBERTY_IMAGES.IC_FILL_COPY}
                                                                style={{ color: "transparent" }}
                                                            />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex items-center space-x-4 mb-4">
                                            <span className="text-white text-3xl font-bold">0.001333</span>
                                            <div className="flex items-center space-x-1 text-green-400">
                                                <span className="text-sm font-medium">4.31% (24h)</span>
                                                <img
                                                    alt="Price Change"
                                                    loading="lazy"
                                                    width={16}
                                                    height={16}
                                                    decoding="async"
                                                    data-nimg={1}
                                                    src={LIBERTY_IMAGES.IC_ARROW_UP}
                                                    style={{
                                                        color: "transparent",
                                                        transform: "rotate(0deg)",
                                                        filter:
                                                            "brightness(0) saturate(100%) invert(64%) sepia(98%) saturate(451%) hue-rotate(81deg) brightness(98%) contrast(89%)"
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="h-px bg-[#242429] my-6" />
                                        <div className="flex items-center mb-6">
                                            <div>
                                                <p className="text-[#9091A0] text-sm mb-1">
                                                    24h volume (Total market)
                                                </p>
                                                <p className="text-[#F7F7F8] text-lg font-bold">$18K</p>
                                            </div>
                                            <div className="w-px h-[32px] bg-[#242429] my-6 mx-12" />
                                            <div>
                                                <p className="text-[#9091A0] text-sm mb-1">
                                                    24h Buy Pressure (LibertySwap)
                                                </p>
                                                <p className="text-[#F7F7F8] text-lg font-bold">$20,354.06</p>
                                            </div>
                                        </div>
                                        <button
                                            onClick={() => navigate('/')}
                                            className="rounded-xl font-medium transition-all duration-300 cursor-pointer text-white hover:opacity-90 px-4 py-2 text-sm    w-[200px]"
                                            style={{ background: "var(--gradient-1)" }}
                                        >
                                            Swap now
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-stretch justify-center gap-4 mt-4">
                                <div className="flex-1">
                                    <div
                                        className="rounded-xl w-full max-w-sm h-full flex flex-col"
                                        style={{
                                            background:
                                                "linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.1) 100%)",
                                            padding: 1
                                        }}
                                    >
                                        <div className="bg-[#0F0F0F] rounded-xl p-4 w-full h-full flex flex-col">
                                            <div className="text-[#9091A0] text-sm font-medium mb-2">
                                                Market cap
                                            </div>
                                            <div className="text-[#F7F7F8] text-xl font-bold mb-1 flex-1">
                                                $58.9M
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <div
                                        className="rounded-xl w-full max-w-sm h-full flex flex-col"
                                        style={{
                                            background:
                                                "linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.1) 100%)",
                                            padding: 1
                                        }}
                                    >
                                        <div className="bg-[#0F0F0F] rounded-xl p-4 w-full h-full flex flex-col">
                                            <div className="text-[#9091A0] text-sm font-medium mb-2">
                                                FDV
                                            </div>
                                            <div className="text-[#F7F7F8] text-xl font-bold mb-1 flex-1">
                                                $58.9M
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <div
                                        className="rounded-xl w-full max-w-sm h-full flex flex-col"
                                        style={{
                                            background:
                                                "linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.1) 100%)",
                                            padding: 1
                                        }}
                                    >
                                        <div className="bg-[#0F0F0F] rounded-xl p-4 w-full h-full flex flex-col">
                                            <div className="text-[#9091A0] text-sm font-medium mb-2">
                                                Buyback
                                            </div>
                                            <div className="text-[#F7F7F8] text-xl font-bold mb-1 flex-1">
                                                $0
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="md:hidden relative">
                            <div
                                className="relative rounded-xl overflow-hidden w-full mx-auto my-auto"
                                style={{
                                    aspectRatio: "343 / 392",
                                    background:
                                        "linear-gradient(rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.1) 100%)",
                                    padding: 1
                                }}
                            >
                                <div className="relative rounded-xl overflow-hidden bg-black h-full">
                                    <div className="absolute inset-0">
                                        <img
                                            alt="Banner Background"
                                            loading="lazy"
                                            decoding="async"
                                            data-nimg="fill"
                                            className="object-cover"
                                            src={LIBERTY_IMAGES.VERTICAL_DEX_BANNER}
                                            style={{
                                                position: "absolute",
                                                height: "100%",
                                                width: "100%",
                                                inset: 0,
                                                color: "transparent"
                                            }}
                                        />
                                    </div>
                                    <div className="relative p-4 h-full flex flex-col justify-between">
                                        <div className="flex-1">
                                            <div className="flex items-center space-x-3 mb-4">
                                                <div className="relative">
                                                    <img
                                                        alt="Dai Stablecoin"
                                                        loading="lazy"
                                                        width={40}
                                                        height={40}
                                                        decoding="async"
                                                        data-nimg={1}
                                                        className="object-contain"
                                                        src={LIBERTY_IMAGES.PDAI_AVATAR}
                                                        style={{ color: "transparent" }}
                                                    />
                                                </div>
                                                <div>
                                                    <h1 className="text-white text-lg font-bold">
                                                        Dai Stablecoin
                                                    </h1>
                                                    <div className="flex items-center space-x-2">
                                                        <span className="text-gray-300 text-xs font-mono">
                                                            0x6B17...1d0F
                                                        </span>
                                                        <button className="text-gray-400 hover:text-white transition-colors">
                                                            <img
                                                                alt="Copy Order ID"
                                                                loading="lazy"
                                                                width={16}
                                                                height={16}
                                                                decoding="async"
                                                                data-nimg={1}
                                                                className="brightness-0 invert"
                                                                src={LIBERTY_IMAGES.IC_FILL_COPY}
                                                                style={{ color: "transparent" }}
                                                            />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex items-center space-x-3 mb-4">
                                                <span className="text-white text-2xl font-bold">
                                                    0.001333
                                                </span>
                                                <div className="flex items-center space-x-1 text-green-400">
                                                    <span className="text-sm font-medium">4.31% (24h)</span>
                                                    <img
                                                        alt="Price Change"
                                                        loading="lazy"
                                                        width={16}
                                                        height={16}
                                                        decoding="async"
                                                        data-nimg={1}
                                                        src={LIBERTY_IMAGES.IC_ARROW_UP}
                                                        style={{
                                                            color: "transparent",
                                                            transform: "rotate(0deg)",
                                                            filter:
                                                                "brightness(0) saturate(100%) invert(64%) sepia(98%) saturate(451%) hue-rotate(81deg) brightness(98%) contrast(89%)"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="h-px bg-[#242429] my-6" />
                                            <div className="space-y-3 mb-4">
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">
                                                        24h volume (Total market)
                                                    </span>
                                                    <span className="text-[#F7F7F8] text-sm font-bold">
                                                        $18K
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">
                                                        24h Buy Pressure (LibertySwap)
                                                    </span>
                                                    <span className="text-[#F7F7F8] text-sm font-bold">
                                                        $20.3K
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-1 flex flex-col justify-center">
                                            <button
                                                className="rounded-xl font-medium transition-all duration-300 cursor-pointer text-white hover:opacity-90 px-4 py-2 text-sm w-full   w-full mb-6"
                                                style={{ background: "var(--gradient-1)" }}
                                            >
                                                Swap now
                                            </button>
                                        </div>
                                        <div className="flex-1">
                                            <div className="space-y-3 mb-4">
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">Market cap</span>
                                                    <span className="text-[#F7F7F8] text-sm font-bold">
                                                        $58.9M
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">FDV</span>
                                                    <span className="text-[#F7F7F8] text-sm font-bold">
                                                        $58.9M
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">Buyback</span>
                                                    <span className="text-[#F7F7F8] text-sm font-bold">$0</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="relative w-full">
                        <div className="hidden md:block relative">
                            <div className="flex justify-center h-full -mr-4">
                                <div className="flex-2">
                                    <div className="pr-4 w-full h-full">
                                        <div
                                            className="w-full h-full rounded-xl"
                                            style={{
                                                background:
                                                    "linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.1) 100%)",
                                                padding: 1
                                            }}
                                        >
                                            <div className="w-full h-full bg-[#0F0F0F] rounded-xl p-4 md:p-6">
                                                <div>
                                                    <div className="flex items-center space-x-3 mb-2">
                                                        <div>
                                                            <h2 className="text-white text-xl font-bold">
                                                                🔥 Burn Summary
                                                            </h2>
                                                            <p className="text-[#9091A0] text-xs md:text-sm mt-1">
                                                                Distribution by USD value
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="my-6">
                                                        <div className="text-white text-2xl md:text-2xl font-bold">
                                                            $255,971.37
                                                        </div>
                                                    </div>
                                                    <div className="space-y-3">
                                                        <div className="flex justify-between md:justify-start items-center">
                                                            <span className="text-white text-xs md:text-sm font-medium">
                                                                192M
                                                            </span>
                                                            <span className="text-orange-400 text-xs md:text-sm font-medium md:ml-4">
                                                                0.43% of total supply
                                                            </span>
                                                        </div>
                                                        <div className="w-full h-3 bg-[#2A2A2A] rounded-full overflow-hidden">
                                                            <div
                                                                className="h-full rounded-full transition-all duration-500"
                                                                style={{
                                                                    width: "0.43%",
                                                                    background:
                                                                        "linear-gradient(90deg, rgb(255, 0, 110) 0%, rgb(255, 107, 53) 50%, rgb(247, 147, 30) 100%)"
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-1 h-full">
                                    <div className="pr-4 w-full h-full flex flex-col justify-center items-center gap-4">
                                        <div
                                            className="rounded-xl w-full max-w-sm h-full flex flex-col"
                                            style={{
                                                background:
                                                    "linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.1) 100%)",
                                                padding: 1
                                            }}
                                        >
                                            <div className="bg-[#0F0F0F] rounded-xl p-4 w-full h-full flex flex-col">
                                                <div className="text-[#9091A0] text-sm font-medium mb-2">
                                                    24h Burn
                                                </div>
                                                <div className="text-[#F7F7F8] text-xl font-bold mb-1 flex-1">
                                                    470.7 pDAI
                                                </div>
                                                <div className="flex items-center justify-between gap-2">
                                                    <div className="text-[#13B95B] text-sm font-medium h-5">
                                                        $0.6
                                                    </div>
                                                    <div className="text-[#9091A0] text-sm font-medium h-5">
                                                        11 txns
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="rounded-xl w-full max-w-sm h-full flex flex-col"
                                            style={{
                                                background:
                                                    "linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.1) 100%)",
                                                padding: 1
                                            }}
                                        >
                                            <div className="bg-[#0F0F0F] rounded-xl p-4 w-full h-full flex flex-col">
                                                <div className="text-[#9091A0] text-sm font-medium mb-2">
                                                    7d Burn
                                                </div>
                                                <div className="text-[#F7F7F8] text-xl font-bold mb-1 flex-1">
                                                    24.1K pDAI
                                                </div>
                                                <div className="flex items-center justify-between gap-2">
                                                    <div className="text-[#13B95B] text-sm font-medium h-5">
                                                        $32.1
                                                    </div>
                                                    <div className="text-[#9091A0] text-sm font-medium h-5">
                                                        90 txns
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="md:hidden">
                            <div
                                className="w-full h-full rounded-xl"
                                style={{
                                    background:
                                        "linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.1) 100%)",
                                    padding: 1
                                }}
                            >
                                <div className="w-full h-full bg-[#0F0F0F] rounded-xl p-4 md:p-6">
                                    <div>
                                        <div className="flex items-center space-x-3 mb-2">
                                            <div>
                                                <h2 className="text-white text-xl font-bold">
                                                    🔥 Burn Summary
                                                </h2>
                                                <p className="text-[#9091A0] text-xs md:text-sm mt-1">
                                                    Distribution by USD value
                                                </p>
                                            </div>
                                        </div>
                                        <div className="my-6">
                                            <div className="text-white text-2xl md:text-2xl font-bold">
                                                $255,971.37
                                            </div>
                                        </div>
                                        <div className="space-y-3">
                                            <div className="flex justify-between md:justify-start items-center">
                                                <span className="text-white text-xs md:text-sm font-medium">
                                                    192M
                                                </span>
                                                <span className="text-orange-400 text-xs md:text-sm font-medium md:ml-4">
                                                    0.43% of total supply
                                                </span>
                                            </div>
                                            <div className="w-full h-3 bg-[#2A2A2A] rounded-full overflow-hidden">
                                                <div
                                                    className="h-full rounded-full transition-all duration-500"
                                                    style={{
                                                        width: "0.43%",
                                                        background:
                                                            "linear-gradient(90deg, rgb(255, 0, 110) 0%, rgb(255, 107, 53) 50%, rgb(247, 147, 30) 100%)"
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col gap-4 mt-4">
                                <div className="flex gap-4">
                                    <div
                                        className="rounded-xl w-full max-w-sm h-full flex flex-col"
                                        style={{
                                            background:
                                                "linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.1) 100%)",
                                            padding: 1
                                        }}
                                    >
                                        <div className="bg-[#0F0F0F] rounded-xl p-4 w-full h-full flex flex-col">
                                            <div className="text-[#9091A0] text-sm font-medium mb-2">
                                                24h Burn
                                            </div>
                                            <div className="text-[#F7F7F8] text-xl font-bold mb-1 flex-1">
                                                470.7 pDAI
                                            </div>
                                            <div className="flex items-center justify-between gap-2">
                                                <div className="text-[#13B95B] text-sm font-medium h-5">
                                                    $0.6
                                                </div>
                                                <div className="text-[#9091A0] text-sm font-medium h-5">
                                                    11 txns
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="rounded-xl w-full max-w-sm h-full flex flex-col"
                                        style={{
                                            background:
                                                "linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.1) 100%)",
                                            padding: 1
                                        }}
                                    >
                                        <div className="bg-[#0F0F0F] rounded-xl p-4 w-full h-full flex flex-col">
                                            <div className="text-[#9091A0] text-sm font-medium mb-2">
                                                7d Burn
                                            </div>
                                            <div className="text-[#F7F7F8] text-xl font-bold mb-1 flex-1">
                                                24.1K pDAI
                                            </div>
                                            <div className="flex items-center justify-between gap-2">
                                                <div className="text-[#13B95B] text-sm font-medium h-5">
                                                    $32.1
                                                </div>
                                                <div className="text-[#9091A0] text-sm font-medium h-5">
                                                    90 txns
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="w-full rounded-xl hidden md:block"
                        style={{
                            background:
                                "linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.1) 100%)",
                            padding: 1
                        }}
                    >
                        <div className="w-full bg-[#0F0F0F] rounded-xl">
                            <h2 className="text-white font-semibold text-lg p-4">Price Chart</h2>
                            <div className="w-full">
                                <iframe
                                    src="https://dexscreener.com/pulsechain/0xfC64556FAA683e6087F425819C7Ca3C558e13aC1?embed=1&theme=dark&loadChartSettings=0&trades=0&info=0"
                                    width="100%"
                                    height={500}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className="w-full rounded-xl"
                        style={{
                            background:
                                "linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.1) 100%)",
                            padding: 1
                        }}
                    >
                        <div className="bg-[#0F0F0F] rounded-xl p-6 w-full">
                            <div className="hidden md:block">
                                <div className="mb-6">
                                    <h2 className="text-white text-xl font-bold mb-2">
                                        Holder Analytics
                                    </h2>
                                    <p className="text-gray-400 text-sm">Distribution by USD value</p>
                                </div>
                                <div className="grid grid-cols-2 gap-4 mb-6">
                                    <div className="bg-[#18181B] rounded-lg p-4">
                                        <div className="text-[#9091A0] text-sm font-medium mb-2">
                                            Total Holders
                                        </div>
                                        <div className="text-[#F7F7F8] text-2xl font-bold">18,971</div>
                                    </div>
                                    <div className="bg-[#18181B] rounded-lg p-4">
                                        <div className="text-[#9091A0] text-sm font-medium mb-2">
                                            Average Holdings
                                        </div>
                                        <div className="text-[#F7F7F8] text-2xl font-bold">
                                            $1,489.4380
                                        </div>
                                    </div>
                                </div>
                                <div className="space-y-4">
                                    <div className="flex items-center space-x-4">
                                        <div className="w-40 text-white text-sm font-medium">
                                            Poseidon ($10K+)
                                        </div>
                                        <div className="flex-1 bg-[#242429] h-5 relative">
                                            <div
                                                className="bg-blue-500 h-5 transition-all duration-300"
                                                style={{ width: "76.6009%" }}
                                            />
                                        </div>
                                        <div className="w-24 text-green-400 text-sm font-medium text-right">
                                            372 (76.60%)
                                        </div>
                                    </div>
                                    <div className="flex items-center space-x-4">
                                        <div className="w-40 text-white text-sm font-medium">
                                            Whale ($1K-$10K)
                                        </div>
                                        <div className="flex-1 bg-[#242429] h-5 relative">
                                            <div
                                                className="bg-blue-500 h-5 transition-all duration-300"
                                                style={{ width: "20.0802%" }}
                                            />
                                        </div>
                                        <div className="w-24 text-green-400 text-sm font-medium text-right">
                                            1785 (20.08%)
                                        </div>
                                    </div>
                                    <div className="flex items-center space-x-4">
                                        <div className="w-40 text-white text-sm font-medium">
                                            Shark ($100-$1K)
                                        </div>
                                        <div className="flex-1 bg-[#242429] h-5 relative">
                                            <div
                                                className="bg-blue-500 h-5 transition-all duration-300"
                                                style={{ width: "3.00895%" }}
                                            />
                                        </div>
                                        <div className="w-24 text-green-400 text-sm font-medium text-right">
                                            2258 (3.01%)
                                        </div>
                                    </div>
                                    <div className="flex items-center space-x-4">
                                        <div className="w-40 text-white text-sm font-medium">
                                            Dolphin (&lt;$100)
                                        </div>
                                        <div className="flex-1 bg-[#242429] h-5 relative">
                                            <div
                                                className="bg-blue-500 h-5 transition-all duration-300"
                                                style={{ width: "0.310044%" }}
                                            />
                                        </div>
                                        <div className="w-24 text-green-400 text-sm font-medium text-right">
                                            14556 (0.31%)
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="md:hidden">
                                <div className="mb-6">
                                    <h2 className="text-white text-xl font-bold mb-2">
                                        Holder Analytics
                                    </h2>
                                    <p className="text-gray-400 text-sm">Distribution by USD value</p>
                                </div>
                                <div className="flex gap-4">
                                    <div className="flex-1 rounded-lg">
                                        <div className="text-gray-400 text-sm font-medium mb-2">
                                            Total Holders
                                        </div>
                                        <div className="text-[#F7F7F8] text-2xl font-bold">18,971</div>
                                    </div>
                                    <div className="flex-1 rounded-lg">
                                        <div className="text-gray-400 text-sm font-medium mb-2">
                                            Average Holdings
                                        </div>
                                        <div className="text-[#F7F7F8] text-2xl font-bold">
                                            $1,489.4380
                                        </div>
                                    </div>
                                </div>
                                <div className="h-px bg-[#242429] my-6" />
                                <div className="space-y-4">
                                    <div className="flex items-center">
                                        <div className="flex-[4] text-white text-sm font-medium">
                                            <div>
                                                Poseidon
                                                <br />
                                                ($10K+)
                                            </div>
                                        </div>
                                        <div className="flex-[6] flex flex-col items-end">
                                            <div className="text-green-400 text-sm font-medium mb-1">
                                                372 (76.60%)
                                            </div>
                                            <div className="bg-[#242429] h-3 w-full relative">
                                                <div
                                                    className="bg-blue-500 h-3 transition-all duration-300"
                                                    style={{ width: "76.6009%" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <div className="flex-[4] text-white text-sm font-medium">
                                            <div>
                                                Whale
                                                <br />
                                                ($1K-$10K)
                                            </div>
                                        </div>
                                        <div className="flex-[6] flex flex-col items-end">
                                            <div className="text-green-400 text-sm font-medium mb-1">
                                                1785 (20.08%)
                                            </div>
                                            <div className="bg-[#242429] h-3 w-full relative">
                                                <div
                                                    className="bg-blue-500 h-3 transition-all duration-300"
                                                    style={{ width: "20.0802%" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <div className="flex-[4] text-white text-sm font-medium">
                                            <div>
                                                Shark
                                                <br />
                                                ($100-$1K)
                                            </div>
                                        </div>
                                        <div className="flex-[6] flex flex-col items-end">
                                            <div className="text-green-400 text-sm font-medium mb-1">
                                                2258 (3.01%)
                                            </div>
                                            <div className="bg-[#242429] h-3 w-full relative">
                                                <div
                                                    className="bg-blue-500 h-3 transition-all duration-300"
                                                    style={{ width: "3.00895%" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <div className="flex-[4] text-white text-sm font-medium">
                                            <div>
                                                Dolphin
                                                <br />
                                                (&lt;$100)
                                            </div>
                                        </div>
                                        <div className="flex-[6] flex flex-col items-end">
                                            <div className="text-green-400 text-sm font-medium mb-1">
                                                14556 (0.31%)
                                            </div>
                                            <div className="bg-[#242429] h-3 w-full relative">
                                                <div
                                                    className="bg-blue-500 h-3 transition-all duration-300"
                                                    style={{ width: "0.310044%" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="w-full rounded-xl"
                        style={{
                            background:
                                "linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.1) 100%)",
                            padding: 1
                        }}
                    >
                        <div className="w-full bg-[#0F0F0F] rounded-xl">
                            <div className="hidden md:block">
                                <div>
                                    <div className="px-6 pt-4">
                                        <h2 className="text-white text-lg font-bold mb-4">Top Holder</h2>
                                    </div>
                                    <div className="overflow-x-auto">
                                        <table className="w-full">
                                            <thead>
                                                <tr className="bg-[#18181B]">
                                                    <th className="text-left text-[#D9D9DE] text-sm font-medium py-2 pl-6">
                                                        Rank
                                                    </th>
                                                    <th className="text-left text-[#D9D9DE] text-sm font-medium py-2">
                                                        Address
                                                    </th>
                                                    <th className="text-right text-[#D9D9DE] text-sm font-medium py-2">
                                                        Total token
                                                    </th>
                                                    <th className="text-right text-[#D9D9DE] text-sm font-medium py-2">
                                                        %
                                                    </th>
                                                    <th className="text-right text-[#D9D9DE] text-sm font-medium py-2 pr-6">
                                                        USD Value
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="border-b border-[#242429] last:border-b-0">
                                                    <td className="py-3 text-[#D9D9DE] text-sm font-medium pl-6">
                                                        #1
                                                    </td>
                                                    <td className="py-3">
                                                        <div className="flex items-center space-x-2">
                                                            <button className="text-[#D9D9DE] text-sm font-mono hover:text-gray-300 transition-colors cursor-pointer">
                                                                0x5ef7...ada4
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right">
                                                        5,528,024,371.1970
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right">
                                                        25.66%
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right pr-6">
                                                        $7,250,833.17
                                                    </td>
                                                </tr>
                                                <tr className="border-b border-[#242429] last:border-b-0">
                                                    <td className="py-3 text-[#D9D9DE] text-sm font-medium pl-6">
                                                        #2
                                                    </td>
                                                    <td className="py-3">
                                                        <div className="flex items-center space-x-2">
                                                            <button className="text-[#D9D9DE] text-sm font-mono hover:text-gray-300 transition-colors cursor-pointer">
                                                                0x5383...d4cb
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right">
                                                        440,365,604.7907
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right">
                                                        2.04%
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right pr-6">
                                                        $577,605.55
                                                    </td>
                                                </tr>
                                                <tr className="border-b border-[#242429] last:border-b-0">
                                                    <td className="py-3 text-[#D9D9DE] text-sm font-medium pl-6">
                                                        #3
                                                    </td>
                                                    <td className="py-3">
                                                        <div className="flex items-center space-x-2">
                                                            <button className="text-[#D9D9DE] text-sm font-mono hover:text-gray-300 transition-colors cursor-pointer">
                                                                0x4fd0...51ef
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right">
                                                        342,513,732.6238
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right">
                                                        1.59%
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right pr-6">
                                                        $449,258.14
                                                    </td>
                                                </tr>
                                                <tr className="border-b border-[#242429] last:border-b-0">
                                                    <td className="py-3 text-[#D9D9DE] text-sm font-medium pl-6">
                                                        #4
                                                    </td>
                                                    <td className="py-3">
                                                        <div className="flex items-center space-x-2">
                                                            <button className="text-[#D9D9DE] text-sm font-mono hover:text-gray-300 transition-colors cursor-pointer">
                                                                0x5376...adea
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right">
                                                        327,915,465.8101
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right">
                                                        1.52%
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right pr-6">
                                                        $430,110.32
                                                    </td>
                                                </tr>
                                                <tr className="border-b border-[#242429] last:border-b-0">
                                                    <td className="py-3 text-[#D9D9DE] text-sm font-medium pl-6">
                                                        #5
                                                    </td>
                                                    <td className="py-3">
                                                        <div className="flex items-center space-x-2">
                                                            <button className="text-[#D9D9DE] text-sm font-mono hover:text-gray-300 transition-colors cursor-pointer">
                                                                0x9244...192e
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right">
                                                        271,058,620.8114
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right">
                                                        1.26%
                                                    </td>
                                                    <td className="py-3 text-[#D9D9DE] text-sm text-right pr-6">
                                                        $355,534.04
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="md:hidden">
                                <div className="px-4 py-3">
                                    <h2 className="text-white text-lg font-medium mb-4">Top Holder</h2>
                                    <div className="space-y-4">
                                        <div className="border-b border-[#242429] last:border-b-0 pb-4 last:pb-0">
                                            <div className="space-y-2">
                                                <div className="flex justify-between items-center">
                                                    <div className="text-[#F97316] text-sm font-medium">#1</div>
                                                    <button className="text-white text-sm font-medium hover:text-gray-300 transition-colors cursor-pointer">
                                                        0x5ef7...ada4
                                                    </button>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">Total token</span>
                                                    <span className="text-white text-sm font-medium">
                                                        5,528,024,371.1970
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">%</span>
                                                    <span className="text-white text-sm font-medium">
                                                        25.66%
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">USD Value</span>
                                                    <span className="text-white text-sm font-medium">
                                                        $7,250,833.17
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="border-b border-[#242429] last:border-b-0 pb-4 last:pb-0">
                                            <div className="space-y-2">
                                                <div className="flex justify-between items-center">
                                                    <div className="text-[#F97316] text-sm font-medium">#2</div>
                                                    <button className="text-white text-sm font-medium hover:text-gray-300 transition-colors cursor-pointer">
                                                        0x5383...d4cb
                                                    </button>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">Total token</span>
                                                    <span className="text-white text-sm font-medium">
                                                        440,365,604.7907
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">%</span>
                                                    <span className="text-white text-sm font-medium">
                                                        2.04%
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">USD Value</span>
                                                    <span className="text-white text-sm font-medium">
                                                        $577,605.55
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="border-b border-[#242429] last:border-b-0 pb-4 last:pb-0">
                                            <div className="space-y-2">
                                                <div className="flex justify-between items-center">
                                                    <div className="text-[#F97316] text-sm font-medium">#3</div>
                                                    <button className="text-white text-sm font-medium hover:text-gray-300 transition-colors cursor-pointer">
                                                        0x4fd0...51ef
                                                    </button>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">Total token</span>
                                                    <span className="text-white text-sm font-medium">
                                                        342,513,732.6238
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">%</span>
                                                    <span className="text-white text-sm font-medium">
                                                        1.59%
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">USD Value</span>
                                                    <span className="text-white text-sm font-medium">
                                                        $449,258.14
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="border-b border-[#242429] last:border-b-0 pb-4 last:pb-0">
                                            <div className="space-y-2">
                                                <div className="flex justify-between items-center">
                                                    <div className="text-[#F97316] text-sm font-medium">#4</div>
                                                    <button className="text-white text-sm font-medium hover:text-gray-300 transition-colors cursor-pointer">
                                                        0x5376...adea
                                                    </button>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">Total token</span>
                                                    <span className="text-white text-sm font-medium">
                                                        327,915,465.8101
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">%</span>
                                                    <span className="text-white text-sm font-medium">
                                                        1.52%
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">USD Value</span>
                                                    <span className="text-white text-sm font-medium">
                                                        $430,110.32
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="border-b border-[#242429] last:border-b-0 pb-4 last:pb-0">
                                            <div className="space-y-2">
                                                <div className="flex justify-between items-center">
                                                    <div className="text-[#F97316] text-sm font-medium">#5</div>
                                                    <button className="text-white text-sm font-medium hover:text-gray-300 transition-colors cursor-pointer">
                                                        0x9244...192e
                                                    </button>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">Total token</span>
                                                    <span className="text-white text-sm font-medium">
                                                        271,058,620.8114
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">%</span>
                                                    <span className="text-white text-sm font-medium">
                                                        1.26%
                                                    </span>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-[#9091A0] text-sm">USD Value</span>
                                                    <span className="text-white text-sm font-medium">
                                                        $355,534.04
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

        </>
    )
}

export default PdaiDex